/* Timbrica — /baggage-size: пройдёт ли эта сумка.
 *
 * ⚠️⚠️ СТОРОНЫ СРАВНИВАЮТСЯ ОТСОРТИРОВАННЫМИ, А НЕ ПОКОЛОННО. «55 × 40 × 20» и
 * «40 × 55 × 20» — одна и та же рамка: сумку в калибратор можно повернуть.
 * Наивное сравнение «ширина с шириной» объявляет не влезающим то, что влезает,
 * и наоборот — а это ровно тот ответ, за которым человек пришёл.
 *
 * ⚠️⚠️ НОРМУ ЗАДАЁТ ТАРИФ, А НЕ АВИАКОМПАНИЯ. У Смартавиа базовый «Smart» даёт
 * 40 × 30 × 20, у Азимута «Лёгкий» — 5 кг вместо 10, у Победы и лоукостеров по
 * базовому бесплатна только личная вещь. Один столбец на перевозчика печатает
 * ЗАГОЛОВОЧНОЕ число — то есть ровно то, которого нет у самого дешёвого билета,
 * а его и покупает большинство. Поэтому там, где `basic` беднее, строка
 * показывает ОБА исхода. Ни CarryFit, ни FitThatBag, ни SizeMyBag этого не
 * делают (проверено 08.09.2026).
 *
 * ⚠️ ОТВЕЧАЕМ СРАЗУ ПРО ВСЕ АВИАКОМПАНИИ. Справочники устроены наоборот:
 * сначала выбери перевозчика, потом смотри числа. Но на пересадочном маршруте
 * авиакомпаний две, а у ещё не купленного билета — все. При этом спрос
 * (Wordstat 08.09.2026) идёт от «размер ручной клади АЭРОФЛОТ» — 38 368/мес
 * против 158 173 у безымянного, — поэтому свой рейс можно пришпилить, и тогда
 * ответ сверху говорит про него, а не про счёт по реестру.
 */

const CFG = window.BAG_CFG || {};
const T = CFG.t || {};
const AIR = CFG.airlines || {};
const DEF = CFG.defaults || {};
const REGIONS = CFG.regions || [];

const tr = (k) => (T[k] != null ? T[k] : k);
const $ = (id) => document.getElementById(id);
const ae = (ev, p) => { try { window.__ae && window.__ae(ev, p || {}); } catch (e) {} };
const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g,
  (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

const IN = 2.54;
const LB = 0.45359237;

/** Насколько близко к пределу считается «впритык», см. */
const TIGHT_CM = 1;

/**
 * Насколько мягкая сумка ужимается в калибраторе, см по КАЖДОЙ стороне.
 * Это не подарок, а наблюдаемое свойство: у сумки без каркаса содержимое
 * перераспределяется, и та же сумка проходит рамку, в которую жёсткий чемодан
 * тех же обмеров не идёт. Держим ОДИН сантиметр и только при явно взведённом
 * переключателе: щедрее — и мы начнём обещать за перевозчика.
 */
const SOFT_CM = 1;

let imperial = false;
let soft = false;

const num = (id) => {
  const v = parseFloat(($(id) && $(id).value || '').replace(',', '.'));
  return isFinite(v) && v > 0 ? v : null;
};

/**
 * ⚠️⚠️ ИЗМЕРЕНИЕ ХРАНИТСЯ ЗДЕСЬ, В САНТИМЕТРАХ, А ПОЛЯ — ТОЛЬКО ЭКРАН.
 *
 * Первая версия держала измерение в самих полях и при смене единиц
 * переписывала их округлённым значением. Округление меняло сумку: 55 см это
 * 21.7 дюйма, а 21.7 дюйма — уже 55.12 см, и та же сумка, у которой человек
 * всего лишь переключил единицы, переставала проходить туда, где проходила
 * секунду назад. Поймано сравнением вердиктов до и после переключения.
 */
const state = { dims: [null, null, null], kg: null };

/** Пришпиленные рейсы — то, чем человек летит. Переживает перезагрузку. */
let pinned = [];
/** Активные регионы; пустой набор = не фильтруем. */
let regionsOn = [];

const FIELDS = ['bag-a', 'bag-b', 'bag-c'];

/** Считать поля в канонические сантиметры. */
function readFields() {
  const k = imperial ? IN : 1;
  FIELDS.forEach((id, i) => {
    const v = num(id);
    state.dims[i] = v == null ? null : v * k;
  });
  const w = num('bag-w');
  state.kg = w == null ? null : w * (imperial ? LB : 1);
}

/** Показать хранимое измерение в текущих единицах. Округление — только здесь. */
function paintFields() {
  const k = imperial ? 1 / IN : 1;
  FIELDS.forEach((id, i) => {
    $(id).value = state.dims[i] == null ? '' : Math.round(state.dims[i] * k * 10) / 10;
  });
  $('bag-w').value = state.kg == null ? '' : Math.round(state.kg * (imperial ? 1 / LB : 1) * 10) / 10;
}

/**
 * Габариты сумки в сантиметрах, по убыванию. null — размеры ещё не введены.
 * Мягкая сумка ужимается ПЕРЕД сортировкой и никогда не уходит в ноль.
 */
function bagCm() {
  if (state.dims.some((x) => x == null)) return null;
  const d = state.dims.map((x) => (soft ? Math.max(1, x - SOFT_CM) : x));
  return d.sort((a, b) => b - a);
}

function bagKg() { return state.kg; }

/**
 * Влезает ли сумка в рамку. Обе тройки отсортированы по убыванию, поэтому
 * сравнение поэлементное — это и есть «повернуть сумку как удобно».
 * Возвращает {ok, margin} — запас по самой тесной стороне.
 */
function fitsBox(bag, box) {
  let margin = Infinity;
  for (let i = 0; i < 3; i++) margin = Math.min(margin, box[i] - bag[i]);
  return { ok: margin >= 0, margin };
}

function fitsSum(bag, sum) {
  const total = bag[0] + bag[1] + bag[2];
  return { ok: total <= sum, margin: sum - total };
}

/** Вердикт по одной норме (ручная кладь или личная вещь). */
function checkLimit(bag, kg, box, sumLimit, maxKg) {
  if (!box && !sumLimit) return null;
  const r = box ? fitsBox(bag, box.slice().sort((a, b) => b - a)) : fitsSum(bag, sumLimit);
  const heavy = maxKg != null && kg != null && kg > maxKg + 1e-9;
  return {
    ok: r.ok && !heavy,
    margin: r.margin,
    // ⚠️ Строго МЕНЬШЕ сантиметра. При «<=» сумка с ровно сантиметровым
    // запасом объявлялась впритык, и предупреждение переставало что-либо
    // значить: оно висело почти на всех строках сразу.
    tight: r.ok && r.margin < TIGHT_CM,
    heavy,
    overBy: heavy ? kg - maxKg : 0,
  };
}

/**
 * Вердикт по перевозчику: заголовочный тариф и, отдельно, самый дешёвый.
 * `basic` описывает только ОТЛИЧИЯ, поэтому недостающее берётся из основного.
 */
function verdictFor(code, bag, kg) {
  const a = AIR[code] || {};
  const cabin = checkLimit(bag, kg, a.cabin, a.cabin_sum, a.cabin_kg);
  const personal = a.personal ? checkLimit(bag, kg, a.personal, null, a.personal_kg) : null;

  let basic = null;
  if (a.basic) {
    const b = a.basic;
    const bCabin = Object.prototype.hasOwnProperty.call(b, 'cabin') ? b.cabin : a.cabin;
    const bCabinKg = b.cabin_kg != null ? b.cabin_kg : a.cabin_kg;
    const bPers = Object.prototype.hasOwnProperty.call(b, 'personal') ? b.personal : a.personal;
    const bPersKg = b.personal_kg != null ? b.personal_kg : a.personal_kg;
    basic = {
      cabin: bCabin ? checkLimit(bag, kg, bCabin, null, bCabinKg) : null,
      personal: bPers ? checkLimit(bag, kg, bPers, null, bPersKg) : null,
      noCabin: !bCabin,
    };
  }

  // Сдаваемый багаж — второй ответ, которого не было вовсе: «габариты багажа»
  // спрашивают отдельно от ручной клади.
  const checkedSum = a.checked_sum || DEF.checked_sum;
  const checkedKg = a.checked_kg || DEF.checked_kg;
  const checked = checkLimit(bag, kg, null, checkedSum, checkedKg);

  return { cabin, personal, basic, checked, onlyPersonal: !!a.only_personal };
}

/** Итог по одной строке: что показать в правом столбце. */
function statusOf(v) {
  if (!v || !v.cabin) return 'unknown';
  if (v.cabin.ok) return v.cabin.tight ? 'tight' : 'yes';
  if (v.personal && v.personal.ok) return 'personal';
  return 'no';
}

const CHIP = {
  yes:      ['v-yes', 'r_yes'],
  tight:    ['v-warn', 'r_tight'],
  personal: ['v-info', 'r_personal'],
  no:       ['v-no', 'r_no'],
  unknown:  ['v-none', 'r_unknown'],
};

function chipHtml(status) {
  const [cls, key] = CHIP[status] || CHIP.unknown;
  return '<span class="v-chip ' + cls + '"><i class="v-dot"></i>' + esc(tr(key)) + '</span>';
}

function fmtCm(v) {
  return imperial ? (Math.round(v / IN * 10) / 10) + ' ' + tr('u_in') : Math.round(v) + ' ' + tr('u_cm');
}

function weightText(kg) {
  return imperial ? (Math.round(kg / LB)) + ' ' + tr('u_lb') : kg + ' ' + tr('u_kg');
}

function boxText(a) {
  if (a.cabin_sum) return tr('sum_limit').replace(':n', fmtCm(a.cabin_sum));
  if (!a.cabin) return '—';
  return a.cabin.map((x) => (imperial ? Math.round(x / IN * 10) / 10 : x)).join(' × ') +
    ' ' + (imperial ? tr('u_in') : tr('u_cm'));
}

/* ─────────────────────────────────────────────────────────────────────────
   Строка списка
   ───────────────────────────────────────────────────────────────────────── */

function rowHtml(code, bag, kg) {
  const a = AIR[code];
  const v = bag ? verdictFor(code, bag, kg) : null;
  const isPin = pinned.includes(code);
  const out = [];

  out.push('<div class="bg-row' + (isPin ? ' pin' : '') + '" data-code="' + esc(code) + '">');

  out.push('<div class="bg-name"><b>' + esc(a.name) + '</b>' +
    '<span class="c">' + esc(code) + ' · ' + esc(a.cc) + '</span></div>');

  out.push('<div class="bg-lim">' + esc(boxText(a)) +
    (a.cabin_kg ? '<span class="sub">' + esc(weightText(a.cabin_kg)) + '</span>' : '') + '</div>');

  out.push('<div class="bg-res">' + (v ? chipHtml(statusOf(v)) : '') +
    (a.url
      ? '<a class="bg-src" href="' + esc(a.url) + '" target="_blank" rel="noopener nofollow"' +
        ' title="' + esc(tr('src_title')) + '" aria-label="' + esc(tr('src_title')) + '">↗</a>'
      : '') +
    '<button type="button" class="bg-pin' + (isPin ? ' on' : '') + '" data-pin="' + esc(code) + '"' +
    ' aria-pressed="' + (isPin ? 'true' : 'false') + '"' +
    ' title="' + esc(tr('pin_title')) + '" aria-label="' + esc(tr('pin_title')) + '">★</button>' +
    '</div>');

  // ⚠️ Второй исход печатается ТОЛЬКО когда он отличается от заголовочного:
  // строка «а по дешёвому тарифу то же самое» — шум на 79 строках.
  // ⚠️ Строка-заметка НЕ повторяет то, что уже сказано группой и плашкой.
  // До правки «Запас меньше сантиметра…» печаталось на КАЖДОЙ из 39 строк
  // группы «ВПРИТЫК», под плашкой «Впритык»: один факт, сказанный трижды в
  // одной строке, перестаёт читаться и растит список вчетверо.
  if (v) {
    const st = statusOf(v);
    const notes = [];
    if (v.onlyPersonal) notes.push(tr('n_only_personal'));
    if (v.basic) {
      const bs = v.basic.noCabin
        ? (v.basic.personal && v.basic.personal.ok ? tr('n_basic_personal_ok') : tr('n_basic_no_cabin'))
        : (v.basic.cabin && !v.basic.cabin.ok && v.cabin && v.cabin.ok ? tr('n_basic_tighter') : '');
      if (bs) notes.push(bs);
    }
    if (v.cabin && v.cabin.heavy) {
      notes.push(tr('n_heavy').replace(':n', weightText(Math.round(v.cabin.overBy * 10) / 10)));
    }
    if (st !== 'tight' && v.cabin && v.cabin.tight) notes.push(tr('n_tight'));
    if (st !== 'personal' && v.cabin && !v.cabin.ok && v.personal && v.personal.ok && !v.onlyPersonal) {
      notes.push(tr('n_personal_ok'));
    }
    if (notes.length) out.push('<p class="bg-fare">' + esc(notes.join(' ')) + '</p>');
  }

  out.push('</div>');
  return out.join('');
}

/* ─────────────────────────────────────────────────────────────────────────
   Ответ сверху
   ───────────────────────────────────────────────────────────────────────── */

function ringHtml(fit, total) {
  const pct = total ? fit / total : 0;
  const R = 42, C = 2 * Math.PI * R;
  const tone = pct >= 0.66 ? 'var(--v-yes)' : pct >= 0.33 ? 'var(--v-warn)' : 'var(--v-no)';
  return '<div class="bg-ring"><svg viewBox="0 0 100 100" aria-hidden="true">' +
    '<circle cx="50" cy="50" r="' + R + '" fill="none" stroke="var(--lg-border)" stroke-width="9"/>' +
    '<circle cx="50" cy="50" r="' + R + '" fill="none" stroke="' + tone + '" stroke-width="9"' +
    ' stroke-linecap="round" stroke-dasharray="' + (C * pct).toFixed(1) + ' ' + C.toFixed(1) + '"/>' +
    '</svg><div class="bg-ring-t">' + Math.round(pct * 100) + '%</div></div>';
}

function renderAnswer(bag, kg) {
  const box = $('bag-answer');
  if (!bag) {
    box.innerHTML = '<p class="tc-eyebrow">' + esc(tr('answer_eyebrow')) + '</p>' +
      '<p class="tc-answer-sub">' + esc(tr('answer_empty')) + '</p>';
    return;
  }

  const all = Object.keys(AIR);
  let fit = 0, tight = 0, personalOnly = 0;
  for (const c of all) {
    const st = statusOf(verdictFor(c, bag, kg));
    if (st === 'yes') fit++;
    else if (st === 'tight') { fit++; tight++; }
    else if (st === 'personal') personalOnly++;
  }

  const parts = [];

  // Пришпилен рейс — отвечаем про НЕГО: это и есть вопрос человека, который
  // уже купил билет. Счёт по реестру уходит на вторую строку.
  if (pinned.length) {
    const rows = pinned.map((c) => {
      const st = statusOf(verdictFor(c, bag, kg));
      return '<div style="display:flex;align-items:center;gap:9px;justify-content:space-between;' +
        'padding:7px 0;border-bottom:1px solid var(--lg-border)">' +
        '<b style="font-size:14px">' + esc(AIR[c].name) + '</b>' + chipHtml(st) + '</div>';
    }).join('');
    parts.push('<p class="tc-eyebrow">' + esc(tr('answer_your_flight')) + '</p>' + rows);
    parts.push('<p class="tc-note">' +
      esc(tr('answer_count').replace(':fit', String(fit)).replace(':total', String(all.length))) + '</p>');
  } else {
    parts.push('<div class="bg-answer">' + ringHtml(fit, all.length) +
      '<div class="bg-answer-main">' +
      '<p class="tc-answer-l">' + esc(tr('answer_eyebrow')) + '</p>' +
      '<div class="tc-answer-v">' + fit + '<span class="u"> / ' + all.length + '</span></div>' +
      '<p class="tc-answer-sub">' + esc(tr('score_note')) + '</p>' +
      '</div></div>');
  }

  const msgs = [];
  if (tight) msgs.push(['warn', tr('score_tight').replace(':n', String(tight))]);
  if (personalOnly) msgs.push(['', tr('score_personal').replace(':n', String(personalOnly))]);

  // Сдаваемый багаж — короткий второй ответ. Считается по отраслевой норме,
  // поэтому говорит «обычно», а не «у вашего перевозчика».
  const ck = checkLimit(bag, kg, null, DEF.checked_sum, DEF.checked_kg);
  if (ck) {
    const sum = Math.round(bag[0] + bag[1] + bag[2]);
    msgs.push([ck.ok ? 'good' : 'bad',
      (ck.ok ? tr('checked_ok') : tr('checked_no'))
        .replace(':sum', fmtCm(sum)).replace(':max', fmtCm(DEF.checked_sum))]);
  }
  for (const [cls, text] of msgs) {
    parts.push('<p class="tc-msg' + (cls ? ' ' + cls : '') + '">' + esc(text) + '</p>');
  }

  box.innerHTML = parts.join('');
  ae('bag_measured', { fit, total: all.length, tight, pinned: pinned.length, soft });
}

/* ─────────────────────────────────────────────────────────────────────────
   Список
   ───────────────────────────────────────────────────────────────────────── */

const GROUP_ORDER = ['pinned', 'yes', 'tight', 'personal', 'no', 'unknown'];

/**
 * Группы, свёрнутые по умолчанию. «Не проходит» и «норма не опубликована» —
 * это 32 + N строк, которые человеку с уже введённой сумкой не нужны
 * развёрнутыми: он пришёл узнать, ГДЕ проходит. Свёрнутые они снимают со
 * страницы ~1 600 px, а `content-visibility` внутри ящика избавляет браузер
 * и от их раскладки.
 */
const COLLAPSED = ['no', 'unknown'];

/**
 * Какой регион раскрыт по умолчанию в справочнике (до ввода размеров).
 * Догадка по языку читателя, и она ВИДИМАЯ: остальные регионы рядом и
 * открываются одним нажатием — то есть ошибка догадки стоит одного клика,
 * а не «моей авиакомпании тут нет».
 */
const HOME_REGION = {
  ru: 'cis', uk: 'cis', en: 'na', de: 'eu', fr: 'eu', es: 'eu', pt: 'eu',
  ko: 'asia', id: 'asia', ar: 'me',
};

function renderList(bag, kg) {
  let codes = Object.keys(AIR);

  if (regionsOn.length) {
    codes = codes.filter((c) => pinned.includes(c) || regionsOn.includes(AIR[c].region));
  }

  const coll = new Intl.Collator(CFG.locale || undefined);
  codes.sort((a, b) => coll.compare(AIR[a].name, AIR[b].name));

  if (!codes.length) {
    $('bag-list').innerHTML = '<div class="bg-empty">' + esc(tr('no_airline')) + '</div>';
    return;
  }

  // ⚠️ Без измерения группировать по вердикту не по чему, но и вываливать 79
  // строк подряд нельзя: на телефоне это 11 739 px страницы. Группируем по
  // РЕГИОНУ и открываем тот, из которого читатель вероятнее всего летит, —
  // остальные свёрнуты. Это и короче, и быстрее для поиска своей строки.
  if (!bag) {
    const home = HOME_REGION[CFG.locale] || 'eu';
    const byReg = {};
    for (const c of codes) (byReg[AIR[c].region] = byReg[AIR[c].region] || []).push(c);
    const html = [];
    for (const r of REGIONS) {
      const list = byReg[r];
      if (!list || !list.length) continue;
      const rows = list.map((c) => rowHtml(c, null, null)).join('');
      const open = (r === home || regionsOn.includes(r)) ? ' open' : '';
      html.push('<details class="tc-drawer bg-group" style="border:0;border-radius:0"' + open + '>' +
        '<summary><span class="bg-group-h" style="padding:0;flex:1 1 auto">' + esc(tr('reg_' + r)) +
        '<span class="n">' + list.length + '</span></span></summary>' +
        '<div class="tc-drawer-body" style="padding:0">' + rows + '</div></details>');
    }
    $('bag-list').innerHTML = html.join('');
    return;
  }

  const buckets = {};
  for (const c of codes) {
    const g = pinned.includes(c) ? 'pinned' : statusOf(verdictFor(c, bag, kg));
    (buckets[g] = buckets[g] || []).push(c);
  }

  const html = [];
  for (const g of GROUP_ORDER) {
    const list = buckets[g];
    if (!list || !list.length) continue;
    const rows = list.map((c) => rowHtml(c, bag, kg)).join('');
    if (COLLAPSED.includes(g)) {
      html.push('<details class="tc-drawer bg-group" style="border:0;border-radius:0">' +
        '<summary><span class="bg-group-h" style="padding:0;flex:1 1 auto">' + esc(tr('g_' + g)) +
        '<span class="n">' + list.length + '</span></span></summary>' +
        '<div class="tc-drawer-body" style="padding:0">' + rows + '</div></details>');
    } else {
      html.push('<div class="bg-group"><div class="bg-group-h">' + esc(tr('g_' + g)) +
        '<span class="n">' + list.length + '</span></div>' + rows + '</div>');
    }
  }
  $('bag-list').innerHTML = html.join('');
}

function render() {
  const bag = bagCm();
  const kg = bagKg();
  renderAnswer(bag, kg);
  renderList(bag, kg);
  renderPinned();
}

/* ─────────────────────────────────────────────────────────────────────────
   Рейка: поиск авиакомпании, пришпиливание, регионы
   ───────────────────────────────────────────────────────────────────────── */

function renderPinned() {
  const box = $('bag-pinned');
  if (!box) return;
  box.innerHTML = pinned.length
    ? pinned.map((c) => '<button type="button" class="tc-chip on" data-unpin="' + esc(c) + '">' +
        esc(AIR[c] ? AIR[c].name : c) + ' ×</button>').join('')
    : '<span class="tc-note" style="margin:0">' + esc(tr('pin_empty')) + '</span>';
}

function renderRegions() {
  const box = $('bag-regions');
  if (!box) return;
  box.innerHTML = REGIONS.map((r) =>
    '<button type="button" class="tc-chip' + (regionsOn.includes(r) ? ' on' : '') +
    '" data-region="' + esc(r) + '" aria-pressed="' + (regionsOn.includes(r) ? 'true' : 'false') + '">' +
    esc(tr('reg_' + r)) + '</button>').join('');
}

function savePins() {
  try { window.__toolSettings && window.__toolSettings.save('baggage-size', 'pinned', pinned.join(',')); } catch (e) {}
}

function openMenu(q) {
  const menu = $('bag-menu');
  const input = $('bag-filter');
  const needle = (q || '').trim().toLowerCase();
  if (!needle) { menu.hidden = true; input.setAttribute('aria-expanded', 'false'); return; }

  const hits = Object.keys(AIR)
    .filter((c) => (AIR[c].name + ' ' + c + ' ' + AIR[c].cc).toLowerCase().includes(needle))
    .slice(0, 8);

  menu.innerHTML = hits.length
    ? hits.map((c) => '<button type="button" class="tc-opt" role="option" data-add="' + esc(c) + '">' +
        esc(AIR[c].name) + '<span class="tc-opt-s">' + esc(c) + '</span></button>').join('')
    : '<div class="tc-empty">' + esc(tr('no_airline')) + '</div>';
  menu.hidden = false;
  input.setAttribute('aria-expanded', 'true');
}

function addPin(code) {
  if (!AIR[code] || pinned.includes(code)) return;
  pinned.push(code);
  savePins();
  ae('bag_pin', { code });
  render();
}

function mount() {
  for (const id of ['bag-a', 'bag-b', 'bag-c', 'bag-w']) {
    const el = $(id);
    if (el) el.addEventListener('input', () => { readFields(); render(); });
  }

  // ── единицы: сегмент вместо <select> ───────────────────────────────────
  const seg = document.querySelector('.tc-seg');
  if (seg) {
    let saved = 'cm';
    try { saved = window.__toolSettings ? window.__toolSettings.load('baggage-size', 'unit', 'cm') : 'cm'; } catch (e) {}
    imperial = saved === 'in';
    seg.querySelectorAll('[data-unit]').forEach((b) => {
      b.classList.toggle('on', (b.dataset.unit === 'in') === imperial);
    });
    readFields();
    seg.addEventListener('click', (e) => {
      const b = e.target.closest('[data-unit]');
      if (!b) return;
      // ⚠️ Числа в полях ПЕРЕСЧИТЫВАЮТСЯ, а не переобъявляются: иначе
      // «55» сантиметров молча становится 55 дюймами, то есть 140 см.
      imperial = b.dataset.unit === 'in';
      seg.querySelectorAll('[data-unit]').forEach((x) => x.classList.toggle('on', x === b));
      try { window.__toolSettings && window.__toolSettings.save('baggage-size', 'unit', imperial ? 'in' : 'cm'); } catch (e) {}
      paintFields();
      ae('bag_units', { imperial });
      render();
    });
  }

  const softBox = $('bag-soft');
  if (softBox) {
    try { window.__toolSettings && window.__toolSettings.bind('baggage-size', softBox, 'soft', false); } catch (e) {}
    soft = !!softBox.checked;
    softBox.addEventListener('change', () => { soft = !!softBox.checked; ae('bag_soft', { soft }); render(); });
  }

  const presets = $('bag-presets');
  if (presets) {
    presets.addEventListener('click', (e) => {
      const b = e.target.closest('[data-dims]');
      if (!b) return;
      // Заготовки заданы в сантиметрах — кладём их прямо в измерение.
      const d = b.getAttribute('data-dims').split(',').map(Number);
      FIELDS.forEach((_, i) => { state.dims[i] = d[i]; });
      paintFields();
      readFields();
      ae('bag_preset', { preset: b.getAttribute('data-name') || '' });
      render();
    });
  }

  // ── поиск авиакомпании ────────────────────────────────────────────────
  const input = $('bag-filter');
  if (input) {
    input.addEventListener('input', () => openMenu(input.value));
    input.addEventListener('focus', () => openMenu(input.value));
  }
  const menu = $('bag-menu');
  if (menu) {
    menu.addEventListener('click', (e) => {
      const b = e.target.closest('[data-add]');
      if (!b) return;
      addPin(b.dataset.add);
      input.value = '';
      menu.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', (e) => {
    if (menu && !menu.hidden && !e.target.closest('#bag-pop')) {
      menu.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }
  });

  // ── пришпиленные и регионы ────────────────────────────────────────────
  const pinBox = $('bag-pinned');
  if (pinBox) {
    pinBox.addEventListener('click', (e) => {
      const b = e.target.closest('[data-unpin]');
      if (!b) return;
      pinned = pinned.filter((c) => c !== b.dataset.unpin);
      savePins();
      render();
    });
  }

  const regBox = $('bag-regions');
  if (regBox) {
    regBox.addEventListener('click', (e) => {
      const b = e.target.closest('[data-region]');
      if (!b) return;
      const r = b.dataset.region;
      regionsOn = regionsOn.includes(r) ? regionsOn.filter((x) => x !== r) : regionsOn.concat(r);
      renderRegions();
      ae('bag_region', { on: regionsOn.join(',') });
      render();
    });
  }

  // Пришпилить/отшпилить прямо из списка.
  const list = $('bag-list');
  if (list) {
    list.addEventListener('click', (e) => {
      const b = e.target.closest('[data-pin]');
      if (!b) return;
      const c = b.dataset.pin;
      if (pinned.includes(c)) pinned = pinned.filter((x) => x !== c);
      else pinned.push(c);
      savePins();
      render();
    });
  }

  try {
    const saved = window.__toolSettings ? window.__toolSettings.load('baggage-size', 'pinned', '') : '';
    pinned = String(saved || '').split(',').filter((c) => AIR[c]);
  } catch (e) { pinned = []; }

  renderRegions();
  render();
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
else mount();
